import React from 'react';
import { Container, Typography, Paper } from '@mui/material';
import ConstructionIcon from '@mui/icons-material/Construction';

const MyPurchaseHistory: React.FC = () => {
  return (
    <Container maxWidth="lg">
      <Typography variant="h4" gutterBottom>
        Purchases
      </Typography>
      <Paper sx={{ p: 6, textAlign: 'center' }}>
        <ConstructionIcon data-testid="ConstructionIcon" sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
        <Typography variant="h6" color="text.secondary" gutterBottom>
          Coming Soon
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Track your purchases from other sellers on ShareStock.
        </Typography>
      </Paper>
    </Container>
  );
};

export default MyPurchaseHistory;
